import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core"
import { IQuestionEditor } from "app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions"
import React, { ChangeEvent, Dispatch, SetStateAction } from "react"
import parse from 'html-react-parser';
import { IAttemptSurvey } from "app_types/admin/survey/survet.types"
import { IoMdArrowDropdown } from "react-icons/io";
import "./CharacterizationSelectQuestion.scss"

interface ICharacterizationSelectQuestionProps {
  question: IQuestionEditor
  attempt: IAttemptSurvey
  setAttempt: Dispatch<SetStateAction<IAttemptSurvey>>
}

function CharacterizationSelectQuestion ({ question, attempt, setAttempt }: ICharacterizationSelectQuestionProps) {
  const indexInAttempt = attempt?.statistics?.findIndex((answer) => answer.question === question.question._id)

  const handleChange = (event: ChangeEvent<{ name?: string; value: unknown }>) => {
    const attemptCopy = {...attempt}
    if (indexInAttempt >= 0) {
      attemptCopy.statistics[indexInAttempt].answer = event.target.value as string
    } else {
      attemptCopy.statistics.push({
        question: question.question._id as string,
        answer: event.target.value as string
      })
    }
    setAttempt(attemptCopy)
  }

  const getCurrentValue = () => {
    return attempt?.statistics?.find((answer) => answer.question === question.question._id)?.answer
  }

  return (
    <div className="characterization-select-question--container">
      <FormControl fullWidth variant='outlined'>
        <InputLabel id={`question-${question._id}`}>{parse(question.question.content) as string}</InputLabel>
        <Select
          labelId={`question-${question._id}`}
          required
          onChange={handleChange}
          value={getCurrentValue()}
          IconComponent={IoMdArrowDropdown}
        >
          {question?.question?.answers?.map((answer) => (
            <MenuItem key={answer._id} value={answer._id}>{parse(answer.content)}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default CharacterizationSelectQuestion
